import ViewColumnIcon from '@mui/icons-material/ViewColumn'
import Tooltip from '@mui/material/Tooltip'
import {
    ColumnsPanelTrigger, ToolbarButton,
} from '@mui/x-data-grid-pro'

export default function SkyBaseColumnMenu() {
    return (
        <Tooltip
            title="Columns"
            data-testid="columns-menu"
        >
            <ColumnsPanelTrigger render={<ToolbarButton />}>
                <ViewColumnIcon fontSize="small" />
            </ColumnsPanelTrigger>
        </Tooltip>
    )
}
